'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _STR_DISPLAY_NAME = require('../_constants/STR_DISPLAY_NAME');

var _STR_DISPLAY_NAME2 = _interopRequireDefault(_STR_DISPLAY_NAME);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _addDisplayName = function _addDisplayName(component, name) {
    component[_STR_DISPLAY_NAME2.default] = name; // eslint-disable-line
    return component;
};

exports.default = _addDisplayName;